import React, { Suspense } from 'react';

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';

const UcapNoTradeDay = LazyLoadable(lazy(() => import('./ucap/UcapNoTradeDay')));
const UcapSettings = LazyLoadable(lazy(() => import('./ucap/UcapSettings')));

const UcapCard = LazyLoadable(lazy(() => import('./ucap/UcapCard')))
// const UcapCardOld = LazyLoadable(lazy(() => import('./ucap-old/UcapCard')))


export const ROUTES_UCAP = [
  {
    path: "/ucap/*",
    element: <Suspense fallback={<LoadingSpinner />}> <UcapCard /></Suspense>,
    children: [
      // {
      //   // index: true,
      //   path: "/",
      //   element: <Navigate to="dashboard" />,
      // },
      // {
      //   path: "/",
      //   element: <UcapCard />,
      // },
      // {
      //   path: "/ucapold",
      //   element: <UcapCardOld />,
      // },
      {
        path: "notradeday",
        element: <UcapNoTradeDay />
      },
      {
        path: "settings",
        element: <UcapSettings />
      }
    ],
  },

];
